// src/components/RecordReturnLink.jsx
// Task #9085 — "‹ {previous record}" affordance for swapped record drawers.
// Receives an already-sanitized entry (services/recordReturn.js); following
// it carries no further return state, so history never stacks.
import { ChevronLeft } from "lucide-react";
import { T } from "../app/tokens.js";
import { recordBackState } from "../services/recordReturn.js";

export function RecordReturnLink({ entry, navigate, testId = "record-return-link", inline = false }) {
  if (!entry || typeof navigate !== "function") return null;
  return (
    <button type="button" data-testid={testId} data-return-path={entry.path}
      onClick={() => navigate(entry.path, recordBackState())}
      aria-label={`Back to ${entry.label}`}
      title={`Back to ${entry.label}`}
      style={{
        display: "inline-flex", alignItems: "center", gap: 2, maxWidth: "100%", margin: inline ? 0 : "0 0 4px -4px", padding: "2px 6px 2px 2px",
        border: 0, borderRadius: 6, background: "transparent", color: T.blue, fontSize: T.fsXs, fontWeight: T.fwBold,
        cursor: "pointer", fontFamily: "inherit", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
      }}>
      <ChevronLeft size={14} aria-hidden="true" style={{ flexShrink: 0 }} />
      <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{entry.label}</span>
    </button>
  );
}

export default RecordReturnLink;
